import { StaticI18nLink } from "../../Link.js";
import {
	NavLink,
	NavLinkExternal,
	NavLinkExternalRaw,
} from "../styles/NavLink.styles.js";

const BaseNavItem = ({
	title,
	onClick,
	href,
	target,
	rel,
	className,
	style,
	isExternal = false,
}) => {
	const handleClick = (e) => {
		if (onClick) {
			onClick(e);
		}
	};

	const handleKeyDown = (e) => {
		if (e.key === "Enter" || e.key === " ") {
			e.preventDefault();
			handleClick(e);
		}
	};

	// Se tem href e é externo, usa link externo (sem StaticI18nLink)
	if (href && isExternal) {
		return (
			<NavLinkExternalRaw
				href={href}
				target={target}
				rel={rel}
				onClick={handleClick}
				onKeyDown={handleKeyDown}
				className={className}
				style={style}
				tabIndex={0}
			>
				{title}
			</NavLinkExternalRaw>
		);
	}

	// Se tem href e é interno, usa StaticI18nLink.
	// passHref é obrigatório no Next 12: sem ele, o href NÃO chega ao filho
	// styled.a e o link renderiza <a> sem href (não crawlável, não abre em nova aba).
	if (href && !isExternal) {
		return (
			<StaticI18nLink href={href} passHref>
				<NavLinkExternalRaw
					onClick={handleClick}
					onKeyDown={handleKeyDown}
					className={className}
					style={style}
					tabIndex={0}
				>
					{title}
				</NavLinkExternalRaw>
			</StaticI18nLink>
		);
	}

	// Caso contrário, renderiza como botão simples
	return (
		<NavLink
			onClick={handleClick}
			onKeyDown={handleKeyDown}
			className={className}
			style={style}
			tabIndex={0}
			type="button"
		>
			{title}
		</NavLink>
	);
};

export default BaseNavItem;
